import { formatServerDateTimeToLocal } from 'utils/dateTimeFormat.js';

const activityTabConfig = {
  tableColConfig: [
    {
      id: 'modifiedDate',
      label: 'Time',
      accessor: d => formatServerDateTimeToLocal(d.modifiedDate, 'dateTime'),
    },
    {
      id: 'reqActionDesc',
      label: 'Action'
    },
    {
      id: 'modifiedByName',
      label: 'User'
    },
  ]
};

export default activityTabConfig;